import React, { useContext, useState, useRef } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { initial_registration, VerifyLoginCredential } from '../../Services/Login/LoginApi';
import { AuthContext, LoaderContext } from '../../Context/ContextProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import ErrorModel from '../../Componant/ErrorModel';
import google from '../../Assets/Images/google.png';
import { getEventsLogin, clearEventsLogin, resumeEventsLogin } from '../../utils/eventsLogin';

const GoogleLoginButton = ({ text }) => {
  const googleLoginButtonRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoginItem, setUserRole } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);

  const [isOpenErrorModel, setOpenErrorModel] = useState(false);
  const [message, setMessage] = useState('');
  const getRedirectPath = () => {
    const redirect = new URLSearchParams(location.search).get('redirect');
    if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
      return redirect;
    }
    return null;
  };
  const redirectAfterLogin = role => {
    if (resumeEventsLogin()) return;
    const redirectPath = getRedirectPath();
    if (role === 'employer') {
      navigate('/employer/dashboard', { replace: true });
      return;
    }
    if (redirectPath) {
      window.location.replace(redirectPath);
      return;
    }
    navigate('/', { replace: true });
  };

  const completeLoginFlow = (loginData, role) => {
    localStorage.clear();
    setUserRole(role);
    localStorage.setItem('login', JSON.stringify(loginData));
    setLoginItem(loginData);
    redirectAfterLogin(role);
  };

  const handleGoogleLoginSuccess = async credentialResponse => {
    setLoader(true);

    try {
      const credential = credentialResponse?.credential;
      if (!credential) throw new Error('Google credential missing.');

      const response = await VerifyLoginCredential({ google_token: credential });

      if (!response?.code?.includes('ERR')) {
        let role = '';
        const message = response.message;

        // Incomplete profiles are eligible for Events; the backend decides access.
        if (message === 'Registration incomplete' && getEventsLogin()) {
          const pendingRole = response?.seeker ? 'seeker' : 'student_unregistered';
          completeLoginFlow({ ...response, role: pendingRole, is_sso: true, provider: 'google' }, pendingRole);
          return;
        }

        if (message.includes('School')) role = 'organization';
        else if (message.includes('student')) role = 'student_registered';
        else if (message.includes('Seeker')) role = 'seeker';
        else if (message === 'Registration incomplete') {
          clearEventsLogin();
          // const registrationRes = await initial_registration({ google_token: credential });
          // if (registrationRes?.code?.includes("ERR")) {
          //     throw new Error(registrationRes.response.data.error);
          // }
          // const userType = registrationRes?.message?.toLowerCase()?.includes("seeker") ? "seeker" : "student";
          // const seekerId = registrationRes?.seeker?.id || registrationRes?.student?.id || registrationRes?.seeker_id;

          //  if (!seekerId) throw new Error("User ID missing after registration.");
          const userType = response?.seeker ? 'seeker' : 'student';
          const seekerId = response?.seeker?.id || response?.student?.id || response?.seeker_id;
          const name = response?.seeker?.name || response?.student?.name;

          if (!seekerId) throw new Error('User ID missing after registration.');
          localStorage.setItem('Type', userType);
          localStorage.setItem('SSOProvider', 'google');
          navigate(`/sign-up?step=2&id=${seekerId}&name=${name}`);
          return;
        }

        const loginData = { ...response, role, is_sso: true, provider: 'google' };
        completeLoginFlow(loginData, role);
      } else {
        const errorMsg = response?.response?.data?.error || response?.response?.data?.message || 'Login failed';

        if (errorMsg === 'No account found for this Google email') {
          const registrationRes = await initial_registration({ google_token: credential });
          if (registrationRes?.code?.includes('ERR')) {
            throw new Error(registrationRes.response.data.error);
          }
          const userType = registrationRes?.message?.toLowerCase()?.includes('seeker') ? 'seeker' : 'student';
          const seekerId = registrationRes?.seeker?.id || registrationRes?.student?.id || registrationRes?.seeker_id;
          // const name = registrationRes?.seeker?.id || registrationRes?.student?.id || registrationRes?.seeker_id;
          const name = registrationRes?.seeker_name || registrationRes?.student_name || response?.seeker?.name || response?.student?.name;
          if (!seekerId) throw new Error('User ID missing after registration.');
          localStorage.setItem('Type', userType);
          localStorage.setItem('SSOProvider', 'google');
          navigate(`/sign-up?step=2&id=${seekerId}&name=${name}`);
          return;
        } else {
          throw new Error(errorMsg);
        }
      }
    } catch (err) {
      console.error(err);
      setMessage(err.message || 'Google Login failed.');
      setOpenErrorModel(true);
    } finally {
      setLoader(false);
    }
  };

  const handleCustomButtonClick = () => {
    if (googleLoginButtonRef.current) {
      const googleButton = googleLoginButtonRef.current.querySelector('div[role="button"]');
      if (googleButton) {
        googleButton.click();
      }
    }
  };

  return (
    <div>
      <button className="google-btn" onClick={handleCustomButtonClick}>
        <img src={google} alt="Google" width={20} />
        <span className="ml-2">{text}</span>
      </button>
      <div ref={googleLoginButtonRef} style={{ display: 'none' }}>
        <GoogleLogin
          onSuccess={handleGoogleLoginSuccess}
          onError={() => {
            setMessage('Google Login Failed');
            setOpenErrorModel(true);
          }}
          useOneTap={false}
        />
      </div>
      <ErrorModel isOpen={isOpenErrorModel} title="Alert!" message={message} buttonText="OK" onClose={() => setOpenErrorModel(false)} />
    </div>
  );
};

export default GoogleLoginButton;
